module.exports = __webpack_public_path__ + "img/block3.ad866df5.png";